document.documentElement.classList.add('jsr');

(function(){
  var c=document.getElementById('gl');
  if(c){
    var gl=c.getContext('webgl',{antialias:false});
    if(!gl){c.style.background='linear-gradient(135deg,#2a1220,#c22960)';}
    else{
      var vs='attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
      var fs='precision mediump float;uniform float t;uniform vec2 r;uniform vec2 m;void main(){vec2 uv=gl_FragCoord.xy/r;vec2 p=uv*2.-1.;p.x*=r.x/r.y;float T=t*.12;float w=0.;w+=sin(p.x*2.1+T*2.0+sin(p.y*1.7+T*1.3)*1.4);w+=sin(length(p-vec2(m.x*1.4-.7,m.y*1.0-.5))*3.2-T*2.4)*.7;w+=sin((p.x+p.y)*1.4-T*1.7)*.5;w/=2.2;vec3 deep=vec3(.086,.059,.075);vec3 rose=vec3(.91,.267,.486);vec3 peach=vec3(1.,.725,.604);vec3 plum=vec3(.36,.13,.30);vec3 col=mix(deep,plum,smoothstep(-1.,.2,w));col=mix(col,rose,smoothstep(.05,.75,w)*.85);col=mix(col,peach,smoothstep(.55,1.,w)*.8);float v=1.-length(uv-.5)*1.05;col*=clamp(v+.25,0.,1.);gl_FragColor=vec4(col,1.);}';
      function sh(t2,s){var x=gl.createShader(t2);gl.shaderSource(x,s);gl.compileShader(x);return x}
      var pr=gl.createProgram();gl.attachShader(pr,sh(gl.VERTEX_SHADER,vs));gl.attachShader(pr,sh(gl.FRAGMENT_SHADER,fs));gl.linkProgram(pr);gl.useProgram(pr);
      var b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),gl.STATIC_DRAW);
      var loc=gl.getAttribLocation(pr,'p');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
      var uT=gl.getUniformLocation(pr,'t'),uR=gl.getUniformLocation(pr,'r'),uM=gl.getUniformLocation(pr,'m');
      var mx=.5,my=.5;addEventListener('pointermove',function(e){mx=e.clientX/innerWidth;my=1-e.clientY/innerHeight});
      var reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      function size(){var d=Math.min(devicePixelRatio,1.6);c.width=c.clientWidth*d;c.height=c.clientHeight*d;gl.viewport(0,0,c.width,c.height)}
      size();addEventListener('resize',size);
      (function frame(t2){gl.uniform1f(uT,t2/1000);gl.uniform2f(uR,c.width,c.height);gl.uniform2f(uM,mx,my);gl.drawArrays(gl.TRIANGLES,0,3);if(!reduced)requestAnimationFrame(frame)})(0);
    }
  }
  var d=document.getElementById('dust');
  if(d && !matchMedia('(prefers-reduced-motion: reduce)').matches){
    var x=d.getContext('2d'),W,H,parts=[];
    function size2(){W=d.width=d.clientWidth;H=d.height=d.clientHeight;parts=[];for(var i=0;i<42;i++)parts.push({x:Math.random()*W,y:Math.random()*H,r:Math.random()*2.4+0.8,s:Math.random()*.5+.15,o:Math.random()*.5+.25,ph:Math.random()*6.28})}
    size2();addEventListener('resize',size2);
    (function frame(t){x.clearRect(0,0,W,H);for(var i=0;i<parts.length;i++){var p=parts[i];p.y-=p.s;if(p.y<-6){p.y=H+6;p.x=Math.random()*W}var tw=.6+.4*Math.sin(t/700+p.ph);x.beginPath();x.arc(p.x,p.y,p.r,0,6.283);x.fillStyle='rgba(255,196,175,'+(p.o*tw)+')';x.shadowColor='rgba(255,160,180,.8)';x.shadowBlur=8;x.fill();x.shadowBlur=0}requestAnimationFrame(frame)})(0);
  }
  var el=document.getElementById('patch3d');
  if(el){
    var hero=document.querySelector('.hero');
    hero.addEventListener('pointermove',function(e){
      var r=el.getBoundingClientRect(),cx=r.left+r.width/2,cy=r.top+r.height/2;
      var dx=(e.clientX-cx)/innerWidth,dy=(e.clientY-cy)/innerHeight;
      el.style.transform='rotateY('+(dx*40)+'deg) rotateX('+(-dy*32)+'deg)';
      el.style.setProperty('--gx',(50+dx*90)+'%');el.style.setProperty('--gy',(35+dy*90)+'%');
    });
    hero.addEventListener('pointerleave',function(){el.style.transform='rotateY(0) rotateX(0)'});
  }
  var ring=document.getElementById('ring3d');
  if(ring){var cards=[].slice.call(ring.children),n=cards.length;var layoutRing=function(){var w=cards[0].offsetWidth||252;var R=Math.ceil((w+28)/(2*Math.sin(Math.PI/n)));cards.forEach(function(c2,i){c2.style.transform='rotateY('+(i*360/n)+'deg) translateZ('+R+'px)'})};layoutRing();addEventListener('resize',layoutRing)}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
  document.querySelectorAll('.reveal').forEach(function(el2){io.observe(el2)});
  var cio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;var el3=e.target,target=+el3.dataset.count,t0=performance.now();
    (function tick(t){var p=Math.min((t-t0)/1200,1);el3.textContent=Math.round(target*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(tick)})(t0);cio.unobserve(el3);
  })},{threshold:.6});
  document.querySelectorAll('[data-count]').forEach(function(el4){cio.observe(el4)});
  var hero2=document.querySelector('.hero'),sticky=document.getElementById('stickyCta');
  if(hero2&&sticky){new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('show',!e.isIntersecting)})},{threshold:.05}).observe(hero2)}
  var intro=document.getElementById('intro');
  if(intro){
    if(sessionStorage.getItem('pl_intro')){intro.remove()}
    else{sessionStorage.setItem('pl_intro','1');setTimeout(function(){if(intro)intro.remove()},3400)}
  }
})();

document.querySelectorAll('.flip').forEach(function(f){
  f.addEventListener('click',function(e){e.stopPropagation();f.classList.toggle('on')});
});

/* acordeon animat (FAQ + ingrediente) */
(function(){
  var reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('details').forEach(function(d){
    var s=d.querySelector('summary');if(!s)return;
    var c=document.createElement('div');c.className='det-body';
    while(s.nextSibling){c.appendChild(s.nextSibling)}
    d.appendChild(c);
    s.addEventListener('click',function(e){
      e.preventDefault();
      if(reduced){d.open=!d.open;return}
      if(d.open){
        c.style.height=c.scrollHeight+'px';c.style.opacity='1';
        requestAnimationFrame(function(){c.style.height='0px';c.style.opacity='0'});
        c.addEventListener('transitionend',function h(ev){if(ev.propertyName!=='height')return;d.open=false;c.style.height='';c.style.opacity='';c.removeEventListener('transitionend',h)});
      }else{
        d.open=true;
        var target=c.scrollHeight;
        c.style.height='0px';c.style.opacity='0';
        requestAnimationFrame(function(){c.style.height=target+'px';c.style.opacity='1'});
        c.addEventListener('transitionend',function h(ev){if(ev.propertyName!=='height')return;c.style.height='';c.removeEventListener('transitionend',h)});
      }
    });
  });
})();

/* plasă de siguranță: dacă observerul nu apucă, totul devine vizibil după 1.4s */
setTimeout(function(){document.querySelectorAll('.reveal:not(.in)').forEach(function(el){el.classList.add('in')})},1400);
/* schimb poze produs cu fade + thumb activ */
(function(){
  var main=document.getElementById('pd-main');if(!main)return;
  var thumbs=document.querySelectorAll('.pd-thumbs img');
  if(thumbs.length){thumbs[0].classList.add('active')}
  thumbs.forEach(function(th){
    th.addEventListener('click',function(){
      thumbs.forEach(function(t){t.classList.remove('active')});
      th.classList.add('active');
      main.style.opacity='0';
      setTimeout(function(){main.src=th.dataset.full||th.src;main.style.opacity='1'},180);
    });
  });
})();

/* v15 — meniu mobil */
(function(){
  var m=document.getElementById('mnav'); if(!m) return;
  var burgers=document.querySelectorAll('.nav-burger');
  var lastFocus=null, lockY=0;
  function open(){
    lastFocus=document.activeElement; lockY=window.scrollY||0;
    m.classList.add('open'); m.setAttribute('aria-hidden','false');
    document.body.classList.add('mnav-lock');
    document.body.style.position='fixed'; document.body.style.top=(-lockY)+'px';
    document.body.style.left='0'; document.body.style.right='0'; document.body.style.width='100%';
    burgers.forEach(function(b){b.setAttribute('aria-expanded','true')});
    var c=m.querySelector('.mnav-close'); if(c) c.focus();
  }
  function close(){
    m.classList.remove('open'); m.setAttribute('aria-hidden','true');
    document.body.classList.remove('mnav-lock');
    document.body.style.position=''; document.body.style.top=''; document.body.style.left=''; document.body.style.right=''; document.body.style.width='';
    window.scrollTo(0,lockY);
    burgers.forEach(function(b){b.setAttribute('aria-expanded','false')});
    if(lastFocus&&lastFocus.focus){try{lastFocus.focus()}catch(e){}}
  }
  burgers.forEach(function(b){ b.addEventListener('click',open); });
  var back=m.querySelector('.mnav-back'); if(back) back.addEventListener('click',close);
  var x=m.querySelector('.mnav-close'); if(x) x.addEventListener('click',close);
  m.querySelectorAll('.mnav-links a, .mnav-cart').forEach(function(a){ a.addEventListener('click',close); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&m.classList.contains('open')) close(); });
})();
